module.exports = __webpack_public_path__ + "static/media/areamap2.6f4e7647.svg";